import { render, staticRenderFns } from "./FieldsetInvoiceParty.yaml?vue&type=template&id=2fa7a278&component"
import script from "./FieldsetInvoiceParty.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetInvoiceParty.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports